import type { UserDropdownMenuProps } from './UserDropdownMenu.types';
import { ListPopover } from 'Components/shared/ListPopover';
import React from 'react';
import { useUserDropdownMenuOptions } from './hooks/useUserDropdownMenuOptions';

export const UserDropdownMenu: React.FC<UserDropdownMenuProps> = ({
  children,
  open,
  onOpenChange,
  setShowMessageStatusModal,
  testid,
}) => {
  const options = useUserDropdownMenuOptions({
    setShowMessageStatusModal,
    testid,
  });

  return (
    <ListPopover
      side="bottom"
      align="end"
      arrowOffset={-40}
      open={open}
      onOpenChange={onOpenChange}
      options={options}
      triggerAsChild
      >
          <button className="inline-flex">{children}</button>
    </ListPopover>
  );
};
